import { QuoteEmailResultsType } from 'data/types';
import { successModal, warningModal } from 'utils/ui';

export function notifyQuoteSendResult(results: QuoteEmailResultsType) {
  if (results.smsSent === false) {
    warningModal('Quote saved, but the text message could not be sent');
    return;
  }
  successModal('Quote sent to customer');
}
